<template>
    <v-container fluid fill-height>
        <v-layout flex align-center justify-center>
            <div class="wrapper-page-not-found">
                <h1 class="headline">Oops, Page Not Found</h1>
                <span id="go-to-home" class="text-center">
                  <router-link to="/">Go to Home Page</router-link>
                </span>
            </div>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'PageNotFound',
        data: () => ({
        }),
        methods: {
        }
    }
</script>

<style>
    .wrapper-page-not-found h1 {
        text-align: center;
    }

    .wrapper-page-not-found {
        width: 100%;
        max-width: 300px;
    }

    .wrapper-page-not-found #go-to-home {
        display: block;
        margin-top: 15px;
    }
</style>
